(function () {
  function initTabs(root) {
    if (root.dataset.maReady) return;
    root.dataset.maReady = 'true';
    root.querySelectorAll('[data-ma-tab]').forEach(function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-ma-tab]').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
          item.setAttribute('aria-selected', item === button ? 'true' : 'false');
        });
        var filter = button.getAttribute('data-ma-tab');
        var section = root.closest('.ma-fragrance') || document;
        section.querySelectorAll('[data-ma-scent]').forEach(function (card) {
          var groups = (card.getAttribute('data-ma-scent') || '').split(/\s+/);
          var matches = groups.indexOf(filter) !== -1 || (filter === 'calm' && groups.indexOf('floral') !== -1);
          card.hidden = filter !== 'all' && !matches;
        });
      });
    });
  }

  function initBenefits(track) {
    if (track.dataset.maReady) return;
    track.dataset.maReady = 'true';
    var section = track.closest('.ma-benefits');
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-ma-benefit-card]'));
    var dots = section ? Array.prototype.slice.call(section.querySelectorAll('[data-ma-benefit-dot]')) : [];
    if (!cards.length || !dots.length) return;

    function activate(index) {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        activate(index);
      });
    });

    var frame = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var nearest = 0;
        var distance = Infinity;
        cards.forEach(function (card, index) {
          var nextDistance = Math.abs((card.offsetLeft - cards[0].offsetLeft) - track.scrollLeft);
          if (nextDistance < distance) {
            distance = nextDistance;
            nearest = index;
          }
        });
        activate(nearest);
      });
    }, { passive: true });
  }

  function initMegaNavigation(header) {
    if (header.dataset.maMegaReady) return;
    header.dataset.maMegaReady = 'true';

    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var siteHeader = header.querySelector('.ma-header');
    var backdrop = header.querySelector('[data-ma-mega-close]');
    var items = Array.prototype.slice.call(header.querySelectorAll('[data-ma-mega-item]'));
    var openItem = null;
    var explicitOpen = false;
    var closeTimer = 0;

    if (!siteHeader || !backdrop || !items.length) return;

    function updateBackdropTop() {
      if (!openItem) return;
      var bottom = Math.max(0, siteHeader.getBoundingClientRect().bottom);
      backdrop.style.setProperty('--ma-mega-backdrop-top', bottom + 'px');
    }

    function setItemState(item, open) {
      var button = item.querySelector('[data-ma-mega-trigger]');
      var panel = item.querySelector('[data-ma-mega-panel]');
      if (!button || !panel) return;
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (button.tagName === 'BUTTON') {
        button.setAttribute('aria-label', (open ? 'Close ' : 'Open ') + panel.getAttribute('aria-label') + ' menu');
      }
      panel.hidden = !open;
    }

    function closeMega(options) {
      window.clearTimeout(closeTimer);
      if (!openItem) return;
      var item = openItem;
      var button = item.querySelector('[data-ma-mega-trigger]');
      setItemState(item, false);
      openItem = null;
      explicitOpen = false;
      header.classList.remove('is-mega-open');
      backdrop.hidden = true;
      if (options && options.returnFocus && button) button.focus();
    }

    function openMega(item, explicit) {
      if (!desktopQuery.matches) return;
      window.clearTimeout(closeTimer);
      if (openItem !== item) {
        if (openItem) setItemState(openItem, false);
        explicitOpen = false;
      }
      openItem = item;
      if (explicit) explicitOpen = true;
      setItemState(item, true);
      header.classList.add('is-mega-open');
      backdrop.hidden = false;
      updateBackdropTop();
    }

    function scheduleClose(item) {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (openItem === item && !item.matches(':hover') && !item.contains(document.activeElement)) closeMega();
      }, 150);
    }

    items.forEach(function (item) {
      var button = item.querySelector('[data-ma-mega-trigger]');
      if (!button) return;

      item.addEventListener('pointerenter', function (event) {
        if (event.pointerType !== 'touch') openMega(item);
      });
      item.addEventListener('pointerleave', function () { scheduleClose(item); });
      item.addEventListener('focusin', function () { window.clearTimeout(closeTimer); });
      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) scheduleClose(item);
        }, 0);
      });
      if (button.tagName === 'BUTTON') {
        button.addEventListener('click', function () {
          if (!desktopQuery.matches) return;
          if (openItem === item && explicitOpen) closeMega();
          else openMega(item, true);
        });
      }
    });

    backdrop.addEventListener('click', function () { closeMega(); });
    document.addEventListener('pointerdown', function (event) {
      if (openItem && !header.contains(event.target)) closeMega();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && openItem) {
        event.preventDefault();
        closeMega({ returnFocus: true });
      }
    });
    window.addEventListener('resize', updateBackdropTop, { passive: true });

    function handleBreakpoint(event) {
      if (!event.matches) closeMega();
    }
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', handleBreakpoint);
    else desktopQuery.addListener(handleBreakpoint);
  }

  function initMenu(menu) {
    if (menu.dataset.maReady) return;
    menu.dataset.maReady = 'true';
    var trigger = menu.querySelector('summary');
    var panel = menu.querySelector('.ma-menu__panel');
    var root = menu.querySelector('[data-ma-mobile-root]');
    var desktopQuery = window.matchMedia('(min-width: 990px)');
    var submenuTriggers = Array.prototype.slice.call(menu.querySelectorAll('[data-ma-mobile-submenu-trigger]'));
    var submenus = Array.prototype.slice.call(menu.querySelectorAll('[data-ma-mobile-submenu]'));
    var activeSubmenu = null;
    var activeSubmenuTrigger = null;

    if (!trigger || !panel || !root) return;

    function resetSubmenu(returnFocus) {
      submenus.forEach(function (submenu) { submenu.hidden = true; });
      submenuTriggers.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      root.hidden = false;
      var previousTrigger = activeSubmenuTrigger;
      activeSubmenu = null;
      activeSubmenuTrigger = null;
      if (returnFocus && previousTrigger) previousTrigger.focus();
    }

    function showSubmenu(button) {
      var key = button.getAttribute('data-ma-mobile-submenu-trigger');
      var submenu = submenus.filter(function (item) {
        return item.getAttribute('data-ma-mobile-submenu') === key;
      })[0];
      if (!submenu) return;

      resetSubmenu(false);
      activeSubmenu = submenu;
      activeSubmenuTrigger = button;
      button.setAttribute('aria-expanded', 'true');
      root.hidden = true;
      submenu.hidden = false;
      window.requestAnimationFrame(function () {
        var heading = submenu.querySelector('h2');
        if (heading) heading.focus();
      });
    }

    function closeMenu(returnFocus) {
      menu.open = false;
      if (returnFocus) window.requestAnimationFrame(function () { trigger.focus(); });
    }

    function setState(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('ma-menu-open', open);
      if (!open) resetSubmenu(false);
      else window.requestAnimationFrame(function () {
        var firstControl = root.querySelector('a, button');
        if (firstControl) firstControl.focus();
      });
    }

    menu.addEventListener('toggle', function () { setState(menu.open); });
    menu.querySelectorAll('[data-ma-menu-close]').forEach(function (button) {
      button.addEventListener('click', function () { closeMenu(true); });
    });
    submenuTriggers.forEach(function (button) {
      button.addEventListener('click', function () { showSubmenu(button); });
    });
    menu.querySelectorAll('[data-ma-mobile-back]').forEach(function (button) {
      button.addEventListener('click', function () { resetSubmenu(true); });
    });
    menu.querySelectorAll('.ma-menu__panel a').forEach(function (link) {
      link.addEventListener('click', function () { menu.open = false; });
    });
    document.addEventListener('keydown', function (event) {
      if (!menu.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (activeSubmenu) resetSubmenu(true);
        else closeMenu(true);
        return;
      }
      if (event.key !== 'Tab') return;

      var activeView = activeSubmenu || root;
      var focusable = Array.prototype.slice.call(activeView.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return !element.closest('[hidden]');
      });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    function handleBreakpoint(event) {
      if (event.matches && menu.open) {
        menu.open = false;
        setState(false);
      }
    }
    if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', handleBreakpoint);
    else desktopQuery.addListener(handleBreakpoint);
  }

  var videoBreakpoint = window.matchMedia('(min-width: 750px)');
  var videoMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function syncEditorialVideos() {
    document.querySelectorAll('.ma-media video').forEach(function (video) {
      if (video.closest('.ma-hero')) return;
      video.autoplay = false;
      var source = video.querySelector('source[media]');
      var visible = !source || window.matchMedia(source.media).matches;
      if (!visible || document.hidden || videoMotion.matches) { video.pause(); return; }
      if (!video.currentSrc) video.load();
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    });
  }
  videoBreakpoint.addEventListener('change', syncEditorialVideos);
  videoMotion.addEventListener('change', syncEditorialVideos);
  document.addEventListener('visibilitychange', syncEditorialVideos);

  function init(scope) {
    scope.querySelectorAll('[data-ma-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-ma-benefit-track]').forEach(initBenefits);
    scope.querySelectorAll('[data-ma-header]').forEach(initMegaNavigation);
    scope.querySelectorAll('[data-ma-menu]').forEach(initMenu);
    syncEditorialVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
